import { Alert } from '@mantine/core'
import { IconSnowflake } from '@tabler/icons-react'

interface FreezePeriod {
  id: number
  name: string
  starts_at: string
  ends_at: string
}

export function FreezePeriodsWarning({ freeze }: { freeze: FreezePeriod | null }) {
  if (!freeze) return null
  return (
    <Alert icon={<IconSnowflake size={16} />} color="red" variant="light" title="Período de Congelamento">
      A janela selecionada cai em <strong>{freeze.name}</strong> (
      {new Date(freeze.starts_at).toLocaleDateString('pt-BR')} –{' '}
      {new Date(freeze.ends_at).toLocaleDateString('pt-BR')}
      ). Mudanças normais e urgentes não podem ser agendadas neste período.
    </Alert>
  )
}
